import React from 'react';
import * as R from 'ramda';
import Form, { DisplayField } from 'common/mdc/form';
import { injectIntl, intlShape, defineMessages } from 'react-intl';
import { Link } from 'found';
import { NodeLink } from '@sma/components/node';
import JobShape from '@sma/components/job/shape';
import AddOn from './addOns';

const messages = defineMessages({
  jobId: {
    id: 'job.field.jobId',
    defaultMessage: 'Job ID',
  },
  nodeId: {
    id: 'job.field.nodeId',
    defaultMessage: 'Node ID',
  },
  vendor: {
    id: 'job.field.vendor',
    defaultMessage: 'Vendor',
  },
  firmware: {
    id: 'job.field.firmware',
    defaultMessage: 'Firmware',
  },
  hardware: {
    id: 'job.field.hardware',
    defaultMessage: 'Hardware',
  },
  driver: {
    id: 'job.field.driver',
    defaultMessage: 'Driver',
  },
  meteringProfiles: {
    id: 'job.field.meteringProfiles',
    defaultMessage: 'Metering profiles',
  },
  registers: {
    id: 'job.field.registers',
    defaultMessage: 'Registers',
  },
  addOns: {
    id: 'job.field.addOns',
    defaultMessage: 'AddOns',
  },
  alarms: {
    id: 'job.field.alarms',
    defaultMessage: 'Alarms',
  },
});

const DetailsForm = ({ job, displayJobLink, intl }) => (
  <div className="device-details-pane">
    <Form style={{ padding: 0 }}>
      <DisplayField label={intl.formatMessage(messages.jobId)}>
        {displayJobLink ?
          <Link to={`/jobs/${encodeURI(job.jobId)}`}>
            {job.jobId}
          </Link> :
          job.jobId
        }
      </DisplayField>
      <DisplayField label={intl.formatMessage(messages.nodeId)}>
        {job.nodeId && (
          <NodeLink nodeId={job.nodeId} terminalReferenceId={job.terminalReferenceId} >
            {job.nodeId}
          </NodeLink>
        )}
      </DisplayField>
      <DisplayField label={intl.formatMessage(messages.vendor)}>
        {job.vendor}
      </DisplayField>
      <DisplayField label={intl.formatMessage(messages.firmware)}>
        {job.firmwareVersion}
      </DisplayField>
      <DisplayField label={intl.formatMessage(messages.hardware)}>
        {job.hardwareVersion}
      </DisplayField>
      <DisplayField label={intl.formatMessage(messages.driver)}>
        {job.driver}
      </DisplayField>
      {job.alarms && (
        <DisplayField label={intl.formatMessage(messages.alarms)} style={{ alignItems: 'start' }}>
          {job.alarms.length}
        </DisplayField>
      )}
      <DisplayField label={intl.formatMessage(messages.meteringProfiles)}>
        {job.meteringProfiles}
      </DisplayField>
      <DisplayField label={intl.formatMessage(messages.registers)}>
        {job.registers}
      </DisplayField>
      <DisplayField label={intl.formatMessage(messages.addOns)} style={{ alignItems: 'start' }}>
        {job.addOns && !R.isEmpty(job.addOns) && (
          <AddOn addOns={job.addOns} />)}
      </DisplayField>
    </Form>
  </div>
);

DetailsForm.propTypes = {
  job: JobShape.isRequired,
  intl: intlShape.isRequired,
};

export default injectIntl(DetailsForm);
